<template>
    <div class="g-header">
        <slot></slot>    
    </div>
</template>
<script>
export default {
    name:'GvuiHeader'
}
</script>
<style lang="scss" scoped>

</style>

